module.exports = __webpack_public_path__ + "img/Night-text.28ff72f9.jpg";